import React, { useState } from 'react';
import { FileText, Download, Loader2, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import FileUpload from '../components/FileUpload';
import ImagePreview from '../components/ImagePreview';
import { generatePDF } from '../utils/pdfGenerator';

function ImageToPdf() {
    const [images, setImages] = useState([]);
    const [isGenerating, setIsGenerating] = useState(false);

    const handleFilesSelected = (files) => {
        const newImages = files.map(file => ({
            id: Math.random().toString(36).substr(2, 9),
            file,
            preview: URL.createObjectURL(file)
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    const handleGeneratePDF = async () => {
        if (images.length === 0) return;

        setIsGenerating(true);
        try {
            await generatePDF(images);
            // No need to download - user will use Ctrl+P in the new window
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try again.');
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="container animate-fade-in">
            <div style={{ marginBottom: '2rem' }}>
                <Link to="/tools/pdf" className="btn btn-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
                    <ArrowLeft size={16} /> Back to PDF Tools
                </Link>
            </div>

            <header className="flex-center" style={{ flexDirection: 'column', marginBottom: '3rem' }}>
                <div className="flex-center" style={{
                    width: '64px',
                    height: '64px',
                    background: 'linear-gradient(135deg, var(--primary), var(--primary-hover))',
                    borderRadius: '1rem',
                    marginBottom: '1rem',
                    color: 'white',
                    boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.4)'
                }}>
                    <FileText size={32} />
                </div>
                <h1>Image to PDF</h1>
                <p>Convert your images to PDF with zero quality loss</p>
            </header>

            <main style={{ maxWidth: '800px', margin: '0 auto' }}>
                <FileUpload onFilesSelected={handleFilesSelected} />

                <ImagePreview images={images} setImages={setImages} />

                {images.length > 0 && (
                    <div className="flex-center mt-4 mb-8 animate-fade-in">
                        <button
                            className="btn btn-primary"
                            onClick={handleGeneratePDF}
                            disabled={isGenerating}
                            style={{ padding: '1rem 2rem', fontSize: '1.1rem' }}
                        >
                            {isGenerating ? (
                                <>
                                    <Loader2 className="animate-spin" /> Generating...
                                </>
                            ) : (
                                <>
                                    <Download /> Download PDF
                                </>
                            )}
                        </button>
                    </div>
                )}
            </main>
        </div>
    );
}

export default ImageToPdf;
